import React, { useState } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { number, object } from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { SellerReviewsModalAsync } from 'dibs-seller-reviews-modal/exports/SellerReviewsModalAsync';
import { StarRating } from 'dibs-elements/exports/StarRating';

import { orderFeedbackEvent } from '../tracking/orderFeedbackTracking';

import styles from './PdpMobileStarRating.scss';

function PdpMobileStarRatingComponent({ feedbackRating, seller, reviews, relay }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    return (
        <div className={styles.container}>
            <StarRating rating={feedbackRating} size="small" />
            <div className={styles.fraction}>
                {feedbackRating ? (
                    <a
                        className={styles.readReviews}
                        onClick={() => {
                            orderFeedbackEvent({
                                action: 'seller reviews expanded',
                                label: 'pdp',
                            });
                            setIsModalOpen(true);
                        }}
                    >
                        <FormattedMessage
                            id="PdpMobileStarRating.readReviews"
                            defaultMessage={`Read {totalResults, number} {totalResults, plural, one {review} other {reviews}}`}
                            values={{
                                totalResults: reviews.totalResults,
                            }}
                        />
                    </a>
                ) : (
                    <FormattedMessage
                        id="PdpMobileStarRating.noReviews"
                        defaultMessage="No Reviews Yet"
                    />
                )}
            </div>
            <SellerReviewsModalAsync
                environment={relay.environment}
                isOpen={isModalOpen}
                onClose={() => {
                    setIsModalOpen(false);
                }}
                sellerId={seller.serviceId}
            />
        </div>
    );
}

PdpMobileStarRatingComponent.propTypes = {
    feedbackRating: number,
    seller: object,
    reviews: object,
    relay: object,
};

export const PdpMobileStarRating = createFragmentContainer(PdpMobileStarRatingComponent, {
    reviews: graphql`
        fragment PdpMobileStarRating_reviews on SellerOrderFeedbackPdpQueryConnection {
            totalResults
        }
    `,
    seller: graphql`
        fragment PdpMobileStarRating_seller on Seller {
            serviceId
        }
    `,
});
